import { Switch } from '@mantine/core';
import switchClassNames from './switch.module.css';
export const switchProps = Switch.extend({
    defaultProps: {
        variant: 'toggle',
        size: 'sm',
    },
    classNames: switchClassNames,
});
